import {NavigateFunction} from "react-router-dom";
import {DataCompanySearchUrl} from "./dataUrls";

// TODO : very poor ?
const navigateToNewSirenForBilans = (navigate: NavigateFunction, siren: string) =>
    navigate(`${DataCompanySearchUrl}/${siren}`); // Extract the url method ?

export default navigateToNewSirenForBilans;
